import { call, fork, takeEvery, put, select } from 'redux-saga/effects';
import { StaticToast } from 'src/components/common';
import { ImActionTypes, nimSdkReceiveMessage } from './action';
// import NIMSDKIM from 'src/utils/nim/index';
import { getNIMHistoryMsgList, sendNIMTxtMessage, sendNIMImageMessage } from './utils';

function* sagaNIMHistoryMsgList(action: any) {
  try {
    const { payload: { success = null } = {} } = action;
    const { timSdkConfig: { currentConversationID = '' } = {}, timGroupChat: { lastMessageTime = '' } = {} } = yield select((state) => state.ims || {});
    const { datail: { inquiryTime = '' } = {} } = yield select((state) => state.inquiry || {});
    const inquiryStartTime = new Date(inquiryTime.replace(/-/g, '/')).getTime();
    let res = yield call(() => getNIMHistoryMsgList({ beginTime: inquiryStartTime ,endTime: lastMessageTime|| Date.now(), to: currentConversationID }));
    yield put({
      type: ImActionTypes.NIMSDK_GET_HISTORY_UNSHIFTMESSAGELIST,
      data: res,
    });
    success && success();
  } catch (err) {
    console.log('sks', err);
    err && err.message && StaticToast.error(err.message);
  }
}

export function* getSagaIMHistoryMsgList() {
  yield takeEvery(ImActionTypes.NIMSDK_GET_HISTORY_MESSAGELIST, sagaNIMHistoryMsgList);
}

// 发送文本消息
function* sagaSendNIMTxtMessage(action: any) {
  const { payload: { message: { msg = '' } = {} } = {} } = action;
  try {
    const { timSdkConfig: { currentConversationID = '' } = {}, timIsReady = false } = yield select((state) => state.ims || {});
    if (!timIsReady) {
      StaticToast.error('IM聊天初始失败，无发发送消息');
      return;
    }
    let res = yield call(() => sendNIMTxtMessage({ to: currentConversationID, text: msg }));
    let { code, data = {} } = res;
    let result = { ...data };
    if (code === 0) {
      result.status = 'sent';
    } else {
      result.err = 'error';
      result.status = 'fail';
    }
    yield put(nimSdkReceiveMessage([result], true));
  } catch (err) {
    err && err.message && StaticToast.error(err.message);
  }
}

export function* sendNIMSDKTxtMessaget() {
  yield takeEvery(ImActionTypes.NIMSDK_SEND_IMTXT_MESSAGE, sagaSendNIMTxtMessage);
}

// 发送图片消息
function* sagaSendNIMImageMessage(action: any) {
  const { payload = {} } = action;
  try {
    const { timSdkConfig: { currentConversationID = '' } = {}, timIsReady = false } = yield select((state) => state.ims || {});
    if (!timIsReady) {
      StaticToast.error('IM聊天初始失败，无发发送消息');
      return;
    }

    let res = yield call(() => sendNIMImageMessage({ to: currentConversationID, fileInput: payload }));
    let { code, data = {} } = res;
    let result = { ...data };
    if (code === 0) {
      result.status = 'sent';
    } else {
      result.err = 'error';
      result.status = 'fail';
    }
    yield put(nimSdkReceiveMessage([result], true));
  } catch (err) {
    err && err.message && StaticToast.error(err.message);
  }
}

export function* sendNIMSDKImageMessaget() {
  yield takeEvery(ImActionTypes.NIMSDK_SEND_IMIMAGE_MESSAGE, sagaSendNIMImageMessage);
}
export default [fork(getSagaIMHistoryMsgList), fork(sendNIMSDKTxtMessaget), fork(sendNIMSDKImageMessaget)];
